import api from './api';

class AdminService {
  // Admin Dashboard
  async getAdminDashboard() {
    try {
      const response = await api.adminRequest('/admin/dashboard/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // User Management
  async getUsersList() {
    try {
      const response = await api.adminRequest('/admin/users/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createUser(userData) {
    try {
      const response = await api.adminRequest('/admin/users/create/', {
        method: 'POST',
        body: JSON.stringify(userData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateUser(userId, userData) {
    try {
      const response = await api.adminRequest(`/admin/users/${userId}/`, {
        method: 'PUT',
        body: JSON.stringify(userData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(userId) {
    try {
      const response = await api.adminRequest(`/admin/users/${userId}/delete/`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Content Management (placeholder for future implementation)
  async getContentData() {
    try {
      const response = await api.adminRequest('/core/content/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateContent(contentData) {
    try {
      const response = await api.adminRequest('/core/content/update/', {
        method: 'PUT',
        body: JSON.stringify(contentData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Service Management (placeholder for future implementation)
  async getServices() {
    try {
      const response = await api.adminRequest('/tax-services/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createService(serviceData) {
    try {
      const response = await api.adminRequest('/tax-services/create/', {
        method: 'POST',
        body: JSON.stringify(serviceData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Document Management
  async getTaxForms() {
    try {
      const response = await api.adminRequest('/documents/admin/tax-forms/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createTaxForm(formData) {
    try {
      const response = await api.adminFileUpload('/documents/admin/tax-forms/', formData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateTaxForm(formId, formData) {
    try {
      const response = await api.adminFileUpload(`/documents/admin/tax-forms/${formId}/`, formData, 'PUT');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async deleteTaxForm(formId) {
    try {
      const response = await api.adminRequest(`/documents/admin/tax-forms/${formId}/`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async toggleTaxFormStatus(formId) {
    try {
      const response = await api.adminRequest(`/documents/admin/tax-forms/${formId}/toggle-status/`, {
        method: 'POST'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new AdminService();
